/** Default browser tab title for the main app (authenticated shell + `UseTitle` fallback). */
export const APP_DOCUMENT_TITLE = "ITP- Project management tool";

// Application Routes
export const ROUTES = {
  // Public Routes
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  VERIFY_EMAIL: "/verify-email",
  VERIFY_EMAIL_SUCCESS: "/verify-email-success",

  // Protected Routes
  DASHBOARD: "/dashboard",
  CLIENTS: "/clients",
  CLIENTS_ADD: "/clients/add",
  CLIENTS_EDIT: "/clients/edit",

  TEAMS: "/teams",

  ISSUES: "/issues",
  RECENT_ISSUES: "/recent-view",
  MY_ISSUE: "my-issue",
  ALL_ISSUE: "all-issue",
  CREATE_ISSUE: "create-issue",
  /** Shareable work item detail (no `/projects` in URL). */
  WORK_ITEM_SHARE_DETAIL: "/issues/work-items/:workItemId",
  /** Legacy bookmark; redirects to {@link WORK_ITEM_SHARE_DETAIL}. */
  PROJECT_WORK_ITEM_DETAIL: "/projects/:projectSlug/work-items/:workItemId",

  TIME_ENTRY: "/time-entry",
  REPORTS: "/reports",
  BILLING: "/billing",
  BILLING_CONFIGURATION: "/billing/configuration",
  BILLING_EXPORTS: "/billing/exports",
  BILLING_SAAS: "/billing/saas-billing",
  USERS: "/users",
  USERS_ADD: "/users/add",
  SETTINGS: "/settings",
  /** Global admin: system lists (segmented tabs, e.g. SaaS module). */
  SETTINGS_SYSTEM_LISTS: "/settings/system-lists",
  PROFILE_EDIT: "/profile/edit",
  PROFILE_TEAM_PROJECTS: "/profile/edit/team/:teamName",
  CHANGE_PASSWORD: "/change-password",
  FORCE_PASSWORD: "/force-password",
  MFA_LOGIN: "/mfa-login",
  MFA_SETUP: "/mfa-setup",

  ALL_USERS: "/users/all-users",
  // Project Dashboard (dynamic)
  PROJECT_DASHBOARD: "/projects/:projectSlug",
  /** Main app — project list / add / edit (mirrors clients pattern) */
  PROJECTS: "/projects",
  PROJECTS_ADD: "/projects/add",
  PROJECTS_EDIT: "/projects/edit",

  /** @deprecated Legacy URLs — App redirects to PROJECTS / PROJECTS_ADD */
  PROJECTS_MANAGEMENT: "/settings/projects-management",
  PROJECTS_MANAGEMENT_ADD: "/settings/projects-management/add",
  /** @deprecated Use ROUTES.PROJECTS_EDIT + /:id — kept for redirects */
  PROJECTS_MANAGEMENT_EDIT: "/settings/projects-management/edit",

  USERS_EDIT: "/users/edit",
};

// API Configuration
export const API_CONFIG = {
  DELAY: 500, // Mock API delay in milliseconds
  TIMEOUT: 30000, // Request timeout in milliseconds
};

// Validation Constants
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 6,
  MAX_PASSWORD_LENGTH: 128,
  MAX_EMAIL_LENGTH: 255,
  MIN_NAME_LENGTH: 2,
  MAX_NAME_LENGTH: 100,
};

// Mock Credentials (for development)
export const MOCK_CREDENTIALS = {
  EMAIL: "info@itptek.com",
  PASSWORD: "itp@2026",
};

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: "authToken",
  USER: "user",
  REMEMBER_ME: "rememberMe",
  /** Email pre-fill on login when REMEMBER_ME is true — set on successful login, cleared on session end if user did not opt in */
  REMEMBERED_EMAIL: "rememberedEmail",
  /** Role id only (from GET /users/me `role.id`) — not names or full role JSON */
  USER_ROLE_ID: "pm_user_role_id",
  /** Path to restore after login when an unauthenticated user hits a protected route */
  AUTH_RETURN_URL: "pm_auth_return_url",
};

/** Removed on login/logout — previously held full `role` JSON in sessionStorage */
export const LEGACY_SESSION_KEYS = {
  USER_ROLE_JSON: "pm_user_role",
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
};

export const KANBAN_DEFAULT_LIMIT = 20;

// Table Configuration
export const TABLE_CONFIG = {
  DEFAULT_ITEMS_PER_PAGE: 10,
};
